canopyPublic.controller("RegisterCompleteController", 
	function() {}
);